// Mobile-only compact money formatter. Keeps @/lib/money (desktop) untouched.
//   coins:  >=1e9 -> "1.23B", >=1e6 -> "1.23M", else "10,054.13" (thousands + 2 dp)
//   cash/bonus: same thresholds, "$"-prefixed ("$1.23M", "$10,054.13")
// Pass { mask: streamerMode } to hide the value (streamer mode).
// Used by the mobile top-bar balance pill so a huge balance abbreviates instead of
// clipping; the CurrencySheet keeps the full precise amount via fmtAmtNum.

export const MASK = "•••••";

function isCashLike(currency) {
  return currency === "cash" || currency === "bonus";
}

// Abbreviate large magnitudes; keep 2 decimals + thousands separators under 1M.
function compactNum(n) {
  const abs = Math.abs(n);
  if (abs >= 1e9) return `${(n / 1e9).toFixed(2)}B`;
  if (abs >= 1e6) return `${(n / 1e6).toFixed(2)}M`;
  return n.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

export function fmtCompact(amount, currency = "coins", opts = {}) {
  if (opts.mask) return MASK;
  const n = Number(amount) || 0;
  const body = compactNum(n);
  return isCashLike(currency) ? `$${body}` : body;
}

export default fmtCompact;
